// extracted by mini-css-extract-plugin
export default {"descriptionBlock":"description_descriptionBlock__lPIVu","itemDesc":"description_itemDesc__weM-c"};